<header class="header-shell hide-on-print">
  <p-toolbar class="header-background">
    <ng-template pTemplate="start">
      <div class="header-brand">
        <span class="brand-pill">
         <!--  <i class="pi pi-shield"></i>
          <span>Secure Workspace</span>-->
        </span> 
        <img class="header-logo" src="assets/images/image.png" alt="PostNord" />
      </div>
    </ng-template>
    <ng-template pTemplate="center"></ng-template>
    <ng-template pTemplate="end">
      @if (!isAuthRoute) {
        <div class="header-actions">
          <p-button
            [label]="isUserLoggedIn ? 'Log Out' : (isAuthActionInProgress ? authButtonLabels.redirecting : authButtonLabels.signIn)"
            [icon]="isUserLoggedIn ? 'pi pi-sign-out' : 'pi pi-sign-in'"
            [loading]="isAuthActionInProgress"
            [disabled]="isAuthActionInProgress"
            styleClass="header-button"
            (click)="logout()"
          ></p-button>
        </div>
      }
    </ng-template>
  </p-toolbar>
</header>